import { FC } from 'react';

import Input from '../Input';
import { groupMoneyValue, sanitizeMoneyValue } from './money-value';
import type { InputMoneyProps } from './types';

/**
 * A money field whose value is the decimal string the API expects, for amounts
 * that must survive verbatim. `InputNumber` cannot be used for those: base-ui's
 * `NumberField` is typed `number | null`, so every amount through it is rounded
 * to a JS double on the way in and re-serialised on the way out.
 *
 * The displayed value is grouped for reading; `onValueChange` always reports the
 * ungrouped string.
 */
const InputMoney: FC<InputMoneyProps> = ({ value, onValueChange, ...rest }) => (
  <Input
    {...rest}
    inputMode="decimal"
    autoComplete="off"
    value={groupMoneyValue(value)}
    onChange={(event) => onValueChange(sanitizeMoneyValue(event.target.value))}
  />
);

InputMoney.displayName = 'InputMoney';

export default InputMoney;
